module.exports = __webpack_public_path__ + "img/solution-hmi-intro.4528bcc4.png";